import React, { useState } from 'react';
import { IonModal, IonButton, IonContent, IonHeader, IonToolbar, IonTitle, IonButtons, IonIcon, IonFooter, IonGrid, IonItem, IonInput, IonCol, IonRow } from '@ionic/react';
import { closeOutline } from 'ionicons/icons';
import { addStatisticCategory } from '../../../redux/statisticCategories/statisticCategories.actions';
import { useAppDispatch } from '../../../redux/store';
import { ErrorToast } from '../../statistics/StatisticsInterfaces';

type AddStatisticCategoryModalProps = {
    showModal: boolean,
    setShowModal: (value: boolean) => void,
    setMessageToast: (toast: ErrorToast) => void,
}

export const AddStatisticCategoryModal: React.FC<AddStatisticCategoryModalProps> = ({ showModal, setShowModal, setMessageToast }: AddStatisticCategoryModalProps) => {
    const initialLabel = '';
    const [label, setLabel] = useState<string>(initialLabel);
    const appDispatch = useAppDispatch();

    const onSave = () => {
        appDispatch(addStatisticCategory(label))
            //@ts-ignore
            .then((res) => {
                setMessageToast({ open: true, message: `Kategorie "${res.label}" erstellt.`, color: 'success' })
            })
            .catch((err) => {
                console.log(err);
                setMessageToast({ open: true, message: `Fehler beim Erstellen der Kategorie.`, color: 'danger' })
            })
            .finally(() => {
                setShowModal(false);
                setLabel(initialLabel);
            })
    }

    return (
        <IonModal isOpen={showModal} className='addStatisticCategoryModal'>
            <IonHeader>
                <IonToolbar color='primary'>
                    <IonTitle>Kategorie hinzufügen</IonTitle>
                    <IonButtons slot="end">
                        <IonButton onClick={() => setShowModal(false)}>
                            <IonIcon icon={closeOutline} />
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            <IonItem className='ion-no-padding'>
                                <IonInput label="Titel" labelPlacement='stacked' value={label} onIonChange={(e) => setLabel(e.detail.value!)}></IonInput>
                            </IonItem>
                        </IonCol>
                    </IonRow>

                </IonGrid>
            </IonContent>
            <IonFooter>
                <IonToolbar>
                    <IonButtons slot="primary">
                        <IonButton fill='clear' onClick={() => setShowModal(false)}>Abbrechen</IonButton>
                        <IonButton fill="solid" color='primary' onClick={onSave}>Speichern</IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonFooter>
        </IonModal>

    );
};